import styled, { css } from 'styled-components';

const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ device }) => (device === 'mobile' ? '16px' : '0px')};
`;

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  ${({ isMobile }) =>
    isMobile &&
    css`
      height: 50vh;
    `}
  > p {
    max-width: 350px;
    white-space: break-spaces;
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

export { WrapperForm, EmptyStateContainer };
